const FULL_STEERING_SPEED = 1.4;
const PIVOT_STEERING_AUTHORITY = 0.65;
const DIRECTION_DEAD_ZONE = 0.08;
const REVERSE_CAMERA_ENTER_SPEED = -0.18;
const REVERSE_CAMERA_EXIT_SPEED = 0.35;
const TRAILER_WHEELBASE = 4.8;
const MAX_TRAILER_ARTICULATION = 1.15;
const TRAILER_HITCH_OFFSET = 1.35;
const BOAT_CENTER_FROM_HITCH = 4;

export const normalizeAngle = (angle: number) =>
  Math.atan2(Math.sin(angle), Math.cos(angle));

export const calculateTurnRate = (
  speed: number,
  steer: number,
  steering: number,
) => {
  const speedAuthority = Math.min(1, Math.abs(speed) / FULL_STEERING_SPEED);
  const authority =
    PIVOT_STEERING_AUTHORITY + (1 - PIVOT_STEERING_AUTHORITY) * speedAuthority;
  const direction =
    Math.abs(speed) < DIRECTION_DEAD_ZONE ? 1 : Math.sign(speed);

  return steer * steering * authority * direction;
};

export const shouldUseReverseCamera = (reversing: boolean, speed: number) =>
  reversing
    ? speed < REVERSE_CAMERA_EXIT_SPEED
    : speed < REVERSE_CAMERA_ENTER_SPEED;

export const calculateTrailerHeading = (
  trailerHeading: number,
  roverHeading: number,
  speed: number,
  delta: number,
) => {
  const articulation = normalizeAngle(roverHeading - trailerHeading);
  const nextHeading =
    trailerHeading +
    (speed / TRAILER_WHEELBASE) * Math.sin(articulation) * delta;
  const nextArticulation = normalizeAngle(roverHeading - nextHeading);

  if (Math.abs(nextArticulation) <= MAX_TRAILER_ARTICULATION)
    return nextHeading;

  return roverHeading - Math.sign(nextArticulation) * MAX_TRAILER_ARTICULATION;
};

export const calculateBoatPosition = (
  x: number,
  z: number,
  roverHeading: number,
  trailerHeading: number,
) => ({
  x:
    x -
    Math.sin(roverHeading) * TRAILER_HITCH_OFFSET -
    Math.sin(trailerHeading) * BOAT_CENTER_FROM_HITCH,
  z:
    z -
    Math.cos(roverHeading) * TRAILER_HITCH_OFFSET -
    Math.cos(trailerHeading) * BOAT_CENTER_FROM_HITCH,
});
